import { atom } from 'jotai';

/**
 * The content gate's element, published for the surfaces that float over the
 * page so they can treat it as a bound — the same way the magic island already
 * treats the site footer. Null when the page has no gate.
 *
 * An element rather than a boolean: the island measures against its own berth
 * line, so it needs the geometry, not somebody else's verdict on it.
 */
export const contentGateElementAtom = atom<HTMLElement | null>(null);
